import { render, staticRenderFns } from "./previewForm.vue?vue&type=template&id=0c1442f3&scoped=true&"
import script from "./previewForm.vue?vue&type=script&lang=js&"
export * from "./previewForm.vue?vue&type=script&lang=js&"
import style0 from "./previewForm.vue?vue&type=style&index=0&id=0c1442f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1442f3",
  null
  
)

export default component.exports